import Api from "@root/components/api";

export default class LkMutation {
    async loadAccessKeys() {
        let query = `query {
            currentUser {    
                accessKeys
            }
        }`;
        let result = await Api.postData('/g', { query: query });
        if (result.errors) {
            return;
        }

        return result.data.currentUser?.accessKeys;        
    }
    
    async mySkillsets() {
        let query = `query {
            currentUser {
                authorOfSkillsets {
                    id, name, language,
                    likes, canLike, total, 
                    topXnodes(i:2) {name},
                    usersCount, topUserAvatars,
                    authorName, authorId, authorAvatar,
                    primarySubject { id, name }
                }
            }
        }`;
        let result = await Api.postData('/g', { query: query });
        if (result.errors) {
            return;
        }

        return result.data.currentUser?.authorOfSkillsets;        
    }
    
    async myCourses() {
        let query = `query {
            currentUser {
                authorOfCourses {
                    id, name, language,
                    likes, canLike, imageUrl, 
                    authorId, authorName, authorAvatar,
                    lessonsCount, usersCount,
                    usersAvatars                    
                }
            }
        }`;
        let result = await Api.postData('/g', { query: query });
        if (result.errors) {
            return;
        }

        return result.data.currentUser?.authorOfCourses;        
    }
    
    async myTasks() {
        let query = `query {
            currentUser {
                authorOfTasks {
                    id, name, likes, canLike, gameType, autoCheck,
                    imageUrl, description, canEdit, my, approved, published,
                    count, time, gameUrl, subjects, language, requirements,
                    primarySkill { 
                        id, name, iknow, exercisePoints,
                        primarySubject { id, name } 
                    },
                    authorId, authorName,
                    skills { id, name, iknow }
                }
            }
        }`;
        let result = await Api.postData('/g', { query: query });
        if (result.errors) {
            return;
        }

        return result.data.currentUser?.authorOfTasks;        
    }
   
    async myChallenges() {
        let query = `query {
            currentUser {
                authorOfChallenges {
                    id name challengeTypes basedOn language imageUrl simple 
                    miniGamesCount questionsCount
                    likes canLike
                    primarySubject { id name likes canLike }
                    miniGames {
                        id name gameType imageUrl language
                        likes canLike
                        primarySkill {
                            id name iknow exercisePoints
                        }
                        skills {
                            id name iknow
                        }
                    }
                }
            }
        }`;
        let result = await Api.postData('/g', { query: query });
        if (result.errors) {
            return;
        }

        return result.data.currentUser?.authorOfChallenges;        
    }
    
    async coursesIStudy() {
        let query = `query {
            currentUser {
                learnCourses {
                    id, name, language,
                    likes, canLike, imageUrl, 
                    authorId, authorName, authorAvatar,
                    lessonsCount, usersCount,
                    usersAvatars                    
                }
            }
        }`;
        let result = await Api.postData('/g', { query: query });
        if (result.errors) {
            return;
        }

        return result.data.currentUser?.learnCourses;        
    }
}